import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import { TablePaginationActions } from '../../../components/Pagination/TablePaginationActions';
import { useDispatch, useSelector } from 'react-redux';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import FilterIcon from '@mui/icons-material/FilterAlt';
import ModalFilter from 'components/Modal/ModalFilter';
import { Grid, Box } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useNavigate, Link } from 'react-router-dom';
import BasicModal from '../../../components/Modal/BasicModal';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { MENU_OPEN } from 'store/actions';
import { getHelp, deleteHelp, searchAllHelp } from 'services/help';
import AnimateButton from 'ui-component/extended/AnimateButton';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import Button from '@mui/material/Button';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#015641',
        color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14
    }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0
    }
}));
export default function GridHelp() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const page = useSelector((state) => state.help.page);
    const question = useSelector((state) => state.help.question);
    const answer = useSelector((state) => state.help.answer);
    const rowsPerPage = useSelector((state) => state.help.rowsPerPage);
    const [allHelp, setAllHelp] = React.useState([]);
    const [success, setSuccess] = React.useState('');
    const [error, setError] = React.useState('');
    const [idDestroyHelp, setIdDestroyHelp] = React.useState('');
    const [openModal, setOpenModal] = React.useState(false);
    const [openModalFilter, setOpenModalFilter] = React.useState(false);

    const withLink = (to, children) => <Link to={to}>{children}</Link>;
    const actions = [
        { icon: withLink('/nova_ajuda', <QuestionMarkIcon sx={{ color: '#015641', marginTop: 1 }} />), name: 'Nova Ajuda' },
        {
            icon: withLink('#/', <FilterIcon sx={{ color: '#015641', marginTop: 1 }} />),
            name: 'Filtros',
            operation: 'filtros'
        }
    ];

    const handleOpenDestroy = (idDestroy) => {
        setIdDestroyHelp(idDestroy);
        setOpenModal(true);
    };

    const handleCloseModalFilter = () => setOpenModalFilter(false);

    const handleCloseModal = () => setOpenModal(false);

    const handleChangePage = (event, newPage) => {
        dispatch({ type: 'SET_PAGE_HELP', payload: newPage });
    };

    const handleChangeRowsPerPage = (event) => {
        dispatch({ type: 'SET_ROWS_PER_PAGE_HELP', payload: parseInt(event.target.value, 10) });
        dispatch({ type: 'SET_PAGE_HELP', payload: 0 });
    };

    function getAllHelp() {
        getHelp(page + 1, rowsPerPage, question, answer).then((resp) => setAllHelp(resp.data));
    }

    function searchHelp() {
        searchAllHelp(question, answer).then((resp) => setAllHelp(resp.data));
    }

    const handleSubmit = () => {
        searchHelp();
        setOpenModalFilter(false);
    };

    const deleteHelpById = () => {
        handleCloseModal();
        deleteHelp(idDestroyHelp)
            .then((resp) => {
                getAllHelp();
                setError('');
                setSuccess(resp.data.success);
                setIdDestroyHelp('');
                setTimeout(() => {
                    setSuccess('');
                }, 3000);
            })
            .catch((e) => {
                console.log(e);
                setSuccess('');
                setError(e.response.data.error);
                setTimeout(() => {
                    setError('');
                }, 4000);
            });
    };

    React.useEffect(() => {
        getAllHelp();
    }, [page, rowsPerPage]);

    React.useEffect(() => {
        const currentIndex = document.location.pathname
            .toString()
            .split('/')
            .findIndex((id) => id === 'Ajuda');
        if (currentIndex > -1) {
            dispatch({ type: MENU_OPEN, id: 'Ajuda' });
        }
    }, []);

    return (
        <>
            <BasicModal
                open={openModal}
                title="Excluir Ajuda"
                handleClose={handleCloseModal}
                description="Tem certeza que deseja excluir o ajuda ?"
                onDelete={deleteHelpById}
            />
            <ModalFilter
                open={openModalFilter}
                title="Filtros"
                handleClose={handleCloseModalFilter}
                content={
                    <form onSubmit={handleSubmit}>
                        <Grid container alignItems="center" justifyContent="center" sx={{ mt: 3 }}>
                            <Grid item xs={12} sm={12} sx={{ marginTop: 3 }}>
                                <TextField
                                    fullWidth
                                    id="outlined-question"
                                    type="text"
                                    label="Pergunta"
                                    value={question}
                                    onChange={(e) => dispatch({ type: 'SET_NAMEQUESTION_HELP', payload: e.target.value })}
                                    name="question"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} sx={{ marginTop: 3 }}>
                                <TextField
                                    fullWidth
                                    id="outlined-answer"
                                    type="text"
                                    label="Resposta"
                                    value={answer}
                                    onChange={(e) => dispatch({ type: 'SET_NAMEANSWER_HELP', payload: e.target.value })}
                                    name="answer"
                                />
                            </Grid>
                            <Grid item>
                                <Box sx={{ mt: 2, mr: 3 }}>
                                    <AnimateButton>
                                        <Button
                                            disableElevation
                                            fullWidth
                                            size="large"
                                            type="button"
                                            variant="contained"
                                            color="error"
                                            onClick={(e) => [
                                                dispatch({ type: 'SET_CLEAR_HELP' }),
                                                setOpenModalFilter(false),
                                                getHelp(page + 1, rowsPerPage).then((resp) => setAllHelp(resp.data))
                                            ]}
                                        >
                                            Limpar Busca
                                        </Button>
                                    </AnimateButton>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box sx={{ mt: 2, mr: 3 }}>
                                    <AnimateButton>
                                        <Button fullWidth size="large" type="submit" color="primary" variant="contained">
                                            Buscar
                                        </Button>
                                    </AnimateButton>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                }
            />
            <TableContainer sx={{ mt: 2, height: '100%', padding: 3 }} component={Paper}>
                <h1
                    style={{
                        font: 'normal normal bold 35px/44px Roboto, sans-serif',
                        letterSpacing: '0px',
                        color: 'var(--unnamed-color-015641)',
                        Color: '#015641',
                        opacity: 1,
                        padding: 15,
                        marginLeft: '2%'
                    }}
                >
                    <QuestionMarkIcon /> AJUDA
                </h1>
                <hr style={{ width: '95%', marginTop: 0 }}></hr>
                <h3
                    style={{
                        font: 'normal normal 300 18px/22px Roboto, sans-serif',
                        letterSpacing: '0px',
                        Color: '#00000',
                        opacity: 1,
                        padding: 15,
                        marginLeft: '2%'
                    }}
                >
                    Gerencie perguntas e respostas
                </h3>
                {error || success ? (
                    <Snackbar open={true} autoHideDuration={6000}>
                        <Alert
                            severity={error ? 'error' : success ? 'success' : ''}
                            sx={{
                                width: '100%',
                                backgroundColor: error ? 'red' : success ? 'green' : 'orange',
                                color: '#FFF'
                            }}
                        >
                            {error ? error : success ? success : ''}
                        </Alert>
                    </Snackbar>
                ) : (
                    ''
                )}
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Pergunta</StyledTableCell>
                            <StyledTableCell>Resposta</StyledTableCell>
                            <StyledTableCell>Ações</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {allHelp.data &&
                            allHelp.data.map((row) => (
                                <StyledTableRow key={row.id}>
                                    <StyledTableCell>{row.question}</StyledTableCell>
                                    <StyledTableCell>{row.answer}</StyledTableCell>
                                    <StyledTableCell style={{ width: 160 }}>
                                        <Tooltip title="Visualizar">
                                            <IconButton onClick={() => navigate({ pathname: `/ajuda/${row.id}/view` })}>
                                                <ViewIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Editar">
                                            <IconButton onClick={() => navigate({ pathname: `/ajuda/${row.id}/edit` })}>
                                                <EditIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Excluir">
                                            <IconButton onClick={() => handleOpenDestroy(row.id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: 'Todos', value: -1 }]}
                                colSpan={3}
                                count={allHelp.total}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: {
                                        'aria-label': 'Registros por Página'
                                    },
                                    native: true
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
            <SpeedDial
                direction="left"
                ariaLabel="SpeedDial basic example"
                sx={{ position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon />}
                FabProps={{
                    sx: {
                        bgcolor: '#015641',
                        '&:hover': {
                            bgcolor: '#0a8f53'
                        }
                    }
                }}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={(e) => (action.operation === 'filtros' ? [e.stopPropagation(), setOpenModalFilter(true)] : '')}
                    />
                ))}
            </SpeedDial>
        </>
    );
}
